export const STATE_PROP_NAME = 'dashboard'
export const MAX_TOP_STORIES_COUNT = 20
export const SIGNIFICANT_HEALTH_CHANGE_THRESHOLD = 1
export const MAX_HEALTH_CHANGES_BEFORE_EXPANDING = 3
